import { type Channel, DefaultGenerics } from 'stream-chat';

/**
 * Retrieves the name of a channel. If the channel's name (`channel.data.name`) is not set,
 * the function returns the name of another member in the channel (excluding the current user).
 * If no other member's name is found, it defaults to `'Unknown'`.
 *
 * @param {Channel<DefaultGenerics>} channel - The channel object from the `stream-chat` library.
 * @param {number} currentUserId - The ID of the current user, used
 * to exclude them when finding another member's name.
 * @returns {string} The name of the channel or another member's
 * name if the channel name is not set.
 *
 * @example
 * const channelName = getChannelName(channel, 123);
 * console.log(channelName); // "John Doe" or "Unknown"
 */

const getChannelName = (channel: Channel<DefaultGenerics>, currentUserId: number) => {
	const members = channel.state?.members || {};
	const member = Object.values(members).find(
		(member) => member?.user_id && member.user_id !== String(currentUserId),
	);
	return channel.data.name || member?.user?.name || 'Unknown';
};

export default getChannelName;
